import React, { Component, Fragment } from "react";

import "../assests/css/App.css";

import NavMenuDesktop from "../components/common/NavMenuDesktop";
import NavMenuMobile from "../components/common/NavMenuMobile";

import FooterDesktop from "../components/common/FooterDesktop";
import FooterMobile from "../components/common/FooterMobile";

import Vehicle from "../components/home/Vehicle";

import SearchDrivers from "../components/cars/SearchDrivers";

import HomeTop from "../components/home/homeTop";
import LimousineBooking from "../components/cars/LimousineBooking";
import AboutUs from "../components/home/AboutUs";
import AirportTransfer from "../components/cars/AirportTransfer";
import CityTour from "../components/cars/CityTour";


class HomePage extends Component {

  constructor(props) {
    super(props);

    this.state = {
      activeTab: "airport-transfer",
    };
  }


  // ================= TAB CHANGE =================

  handleTabChange = (tab) => {

    this.setState({
      activeTab: tab,
    });

  };


  // ================= DISPLAY COMPONENT =================

  renderActiveComponent() {

    const { activeTab } = this.state;

    switch (activeTab) {

      // ================= AIRPORT TRANSFER =================

      case "airport-transfer":
        return <AirportTransfer />;


      // ================= CITY TOURS =================

      case "city-tours":
        return <CityTour />;


      // ================= LIMOUSINE BOOKING =================

      case "limousine-booking":
        return <LimousineBooking />;


      // ================= SEARCH DRIVERS =================

      case "search-drivers":
        return <SearchDrivers />;


      // ================= DEFAULT =================

      default:
        return <AirportTransfer />;
    }
  }


  // ================= RENDER =================

  render() {

    return (

      <Fragment>

        {/* ================= HOME TOP ================= */}

        <HomeTop />


        {/* ================= DESKTOP ================= */}

        <div className="Desktop">

          <NavMenuDesktop />


          {/* ================= VEHICLE MENU ================= */}

          <Vehicle
            activeTab={this.state.activeTab}
            onTabChange={this.handleTabChange}
          />


          {/* ================= TAB CONTENT ================= */}

          <div className="home-tab-content">

            {this.renderActiveComponent()}

          </div>

        </div>


        {/* ================= MOBILE ================= */}

        <div className="Mobile">

          <NavMenuMobile />


          {/* ================= VEHICLE MENU ================= */}

          <Vehicle
            activeTab={this.state.activeTab}
            onTabChange={this.handleTabChange}
          />


          {/* ================= TAB CONTENT ================= */}

          <div className="home-tab-content">

            {this.renderActiveComponent()}

          </div>

        </div>


        {/* ================= ABOUT US ================= */}

        <AboutUs />


        {/* ================= DESKTOP FOOTER ================= */}

        <div className="Desktop">

          <FooterDesktop />

        </div>


        {/* ================= MOBILE FOOTER ================= */}

        <div className="Mobile">

          <FooterMobile />

        </div>


        {/* =====================================================
             WHATSAPP FLOATING CHAT BUTTON
             ===================================================== */}

        <a
  href="https://wa.me/974XXXXXXXX?text=Hello%20Al%20Saad%20Rent%20a%20Car%2C%20I%20would%20like%20to%20know%20more."
  className="whatsapp-modern"
  target="_blank"
  rel="noopener noreferrer"
  aria-label="Chat with us on WhatsApp"
>
  <i className="fab fa-whatsapp"></i>

  <span className="whatsapp-tooltip">
    Chat with us
  </span>
</a>


      </Fragment>

    );
  }
}


export default HomePage;